<template>
  <div>
    <Header :From="'Register'" />
    <CContainer class="d-flex content-center min-vh-90" v-if="!loggedIn">
      <CRow>
        <CCol>
          <CCardGroup>
            <CCard class="p-4 mt-5" style="min-width: 35vw">
              <CCardBody>
                <img src="/img/logo.png" width="180" />
                <CForm @submit.prevent="register" method="POST">
                  <h1>{{ $t("Auth.Register") }}</h1>
                  <CInput
                    v-model="user.name"
                    :placeholder="$t('Auth.NameLastName')"
                    autocomplete="name"
                  >
                    <template #prepend-content
                      ><CIcon name="cil-user"
                    /></template>
                  </CInput>
                  <!-- <CInput v-model="user.phone" :placeholder="$t('Profile.PhoneNumber')" autocomplete="phone" >
                    <template #prepend-content><CIcon name="cil-phone"/></template>
                  </CInput> -->
                  <div style="margin-bottom: 20px">
                    <VuePhoneNumberInput
                      v-model="user.phone"
                      :default-country-code="selectedCountryIsoCode"
                      :show-code-on-list="false"
                      :translations="translations"
                      :disabled="optForVerification"
                      :border-radius="0"
                      :onlyCountries="preferredCountries"
                      @update="countrySelectorCallback"
                    />
                  </div>
                  <CInput
                    v-model="user.email"
                    :placeholder="$t('Auth.Email')"
                    autocomplete="email"
                  >
                    <template #prepend-content
                      ><CIcon name="cil-envelope-closed"
                    /></template>
                  </CInput>
                  <CRow class="text-left mb-2">
                    <CCol col="12" style="margin: 5px 0;">
                      <label for="Age">{{ $t("Auth.AgeGroup") }}</label>
                      <select
                        id="Age"
                        v-model="user.age"
                        style="width: 100%;border: 1px solid #ddd;height:30px;border-radius:5px;padding: 0 5px;"
                      >
                        <option value="13-19">13-19</option>
                        <option value="20-29" selected>20-29</option>
                        <option value="30-39">30-39</option>
                        <option value="40-49">40-49</option>
                        <option value="50+">50+</option>
                      </select>
                    </CCol>
                    <CCol col="4" class="bold">{{ $t("Auth.Gender") }} :</CCol>
                    <CCol col="4">
                      <CInputRadio
                        :label="$t('Auth.Male')"
                        type="radio"
                        value="M"
                        name="gender"
                      ></CInputRadio>
                    </CCol>
                    <CCol col="4">
                      <CInputRadio
                        :label="$t('Auth.Female')"
                        type="radio"
                        value="F"
                        name="gender"
                      ></CInputRadio>
                    </CCol>
                  </CRow>

                  <!--
                  <CInput
                          v-model="password"
                          prependHtml="<i class='cui-lock-locked'></i>"
                          placeholder="Mot de passe"
                          type="password"
                          autocomplete="curent-password"
                  >
                    <template #prepend-content><CIcon name="cil-lock-locked"/></template>
                  </CInput>
                  -->
                  <CRow>
                    <CCol col="12" class="text-left">
                      <CButton
                        type="submit"
                        color="primary"
                        class="px-4 w-100"
                        style=" background: #ef86c1; border-color: #ef86c1; "
                        >{{ $t("Auth.CreateAccount") }}</CButton
                      >
                    </CCol>
                  </CRow>

                  <CRow>
                    <CCol col="12" class="text-center">
                      <hr />
                      <p class="text-muted">
                        {{ $t("Auth.AlreadyHaveAccount") }}
                        <a href="#" @click="$router.push('/shop/login')">{{
                          $t("Auth.ClickHereLogin")
                        }}</a>
                      </p>
                    </CCol>
                  </CRow>
                </CForm>
              </CCardBody>
            </CCard>
          </CCardGroup>
        </CCol>
      </CRow>
    </CContainer>
  </div>
</template>

<script>
import { shopService } from "../../_services/shop.service";
import Header from "../../components/Header.vue";

export default {
  name: "Register",
  components: {
    Header,
  },
  data: () => ({
    preferredCountries: ["TN", "SA", "AE"],
    selectedCountryIsoCode: "TN",
    phoneNumber: "",
    translations: {
      countrySelectorLabel: "Code pays",
      countrySelectorError: "Choisir un pays",
      phoneNumberLabel: "Numéro de téléphone",
      example: "Exemple :",
    },
    optForVerification: false,
    phone_prefix: null,
    user: {
      name: "",
      phone: "",
      email: "",
      gender: "M",
      age: "",
      prefix: null,
    },
    offset: 0,
    loggedIn: false,
    navbarOptions: {
      elementId: "main-navbar",
      isUsingVueRouter: true,
      mobileBreakpoint: 992,
      brandImagePath: "./",
      brandImage: "/img/logo.png",
      brandImageAltText: "brand-image",
      collapseButtonOpenColor: "#661c23",
      collapseButtonCloseColor: "#661c23",
      showBrandImageInMobilePopup: true,
      ariaLabelMainNav: "Main Navigation",
      tooltipAnimationType: "shift-away",
      tooltipPlacement: "bottom",
      menuOptionsLeft: [],
      menuOptionsRight: [
        /*
        {
          type: "link",
          text: "Accueil",
          path: { name: "home"},
        },
        {
          type: "link",
          text: "À propos",
          path: { name: "about"},
        },
        {
          type: "link",
          text: "Prix",
          path: { name: "pricing"},
        },
        {
          type: "link",
          text: "Contactez-nous",
          path: { name: "contact"},
        },

        {
          type: "button",
          text: "Créer un compte",
          path: { name: "shopper_signup" },
          class: "button-pink-outline"
        },
        */
        {
          type: "button",
          text: "S'identifier",
          path: { name: "ShopperLogin" },
          class: "button-pink",
          iconRight:
            '<svg id="i-arrow-right" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" width="32" height="32" fill="none" stroke="currentcolor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"> <path d="M22 6 L30 16 22 26 M30 16 L2 16" /> </svg>',
        },

        /*
        {
          type: "button",
          text: "Mon panier",
          class: "my-basket",
          iconRight: '<svg id="i-cart" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" width="32" height="32" fill="none" stroke="currentcolor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2">\n' +
                  '    <path d="M6 6 L30 6 27 19 9 19 M27 23 L10 23 5 2 2 2" />\n' +
                  '    <circle cx="25" cy="27" r="2" />\n' +
                  '    <circle cx="12" cy="27" r="2" />\n' +
                  '</svg>',
          path: { name: "shopper_cart" },
          }

         */
      ],
    },
  }),

  methods: {
    countrySelectorCallback(data) {
      console.log(data);
      this.user.prefix = "+" + data.countryCallingCode;
      this.phoneNumber = data.nationalNumber;
      this.selectedCountryIsoCode = data.countryCode;
      this.validPhoneNumber = data.isValid;
    },
    register() {
      let loader = this.$loading.show();
      this.user.phone = this.phoneNumber;
      shopService
        .register(this.user)
        .then(
          function() {
            this.$router.push({
              name: "ShopperLoginVerification",
              params: { phone: this.user.phone },
            });
          }.bind(this)
        )
        .catch(
          function() {
            this.$toast.error(
              this.$t("Toast.FailRegister")
            );
          }.bind(this)
        )
        .finally(
          function() {
            loader.hide();
          }.bind(this)
        );
    },
  },
};
</script>
<style>
.vue-tinder {
  position: absolute;
  z-index: 1;
  left: 0;
  right: 0;
  top: -50px;
  margin: auto;
  width: calc(100% - 20px);
  height: calc(100% - 23px - 65px - 47px - 16px);
  min-width: 300px;
  max-width: 355px;
}

.nope-pointer,
.like-pointer {
  position: absolute;
  z-index: 1;
  top: 20px;
  width: 64px;
  height: 64px;
}

.nope-pointer {
  right: 10px;
}

.like-pointer {
  left: 10px;
}

.super-pointer {
  position: absolute;
  z-index: 1;
  bottom: 80px;
  left: 0;
  right: 0;
  margin: auto;
  width: 112px;
  height: 78px;
}

.rewind-pointer {
  position: absolute;
  z-index: 1;
  top: 20px;
  right: 10px;
  width: 112px;
  height: 78px;
}

.pic {
  width: 100%;
  height: 100%;
  background-size: cover;
  background-position: center;
}

.btns {
  position: absolute;
  left: 0;
  right: 0;
  bottom: 30px;
  margin: auto;
  height: 65px;
  display: flex;
  align-items: center;
  justify-content: center;
  min-width: 300px;
  max-width: 355px;
}

.btns img {
  margin-right: 12px;
  box-shadow: 0 4px 9px rgba(0, 0, 0, 0.15);
  border-radius: 50%;
  cursor: pointer;
  -webkit-tap-highlight-color: transparent;
}

.btns img:nth-child(2n + 1) {
  width: 53px;
}

.btns img:nth-child(2n) {
  width: 65px;
}

.btns img:nth-last-child(1) {
  margin-right: 0;
}
</style>
<style lang="scss">
.vnb {
  .button-pink {
    color: #fff;
    background: #ef86c1;
    &:hover {
      background: darken(#ef86c1, 10%);
    }
  }

  .button-pink-outline {
    background: #fff;
    border: 1px solid #ef86c1;
    color: #ef86c1;
    &:hover {
      border-color: darken(#ef86c1, 10%);
      color: darken(#ef86c1, 10%);
    }
  }

  .my-basket {
    background: #fff;
    color: #ef86c1;
    &:hover {
      color: darken(#ef86c1, 10%);
    }
  }
}

.vnb__popup__bottom__menu-options__option__link:hover {
  color: #333;
  text-decoration: none;
  background: #f3f3f3;
  border-left: 2px solid #ef86c1;
}

.vnb__brand-image-wrapper__link__image {
  max-height: 40px !important;
}
</style>
